import { MenuItem } from "@material-ui/core";
import React from "react";

export const isLegacyFamilyPlan = familyPlan => {
  const newPlans = ["ESSENTIAL", "PREMIUM", "EXCLUSIVE"];

  if (!familyPlan) {
    return false;
  }

  return !newPlans.includes(familyPlan);
};

export const isEssentialPlan = familyPlan => {
  if (!familyPlan) return false;

  return familyPlan === "ESSENTIAL";
};

export const getFamilyPlanOptions = (scope, filterProcessesNoCourtesy) => {
  const items = [];


    if (filterProcessesNoCourtesy.length > 0) {
      items.push(
        <MenuItem value="NONE" key="NONE">
          Plano Cidadão
        </MenuItem>
      );
    }

    if (filterProcessesNoCourtesy.length >= 3) {
      items.push(
        <MenuItem
          value="INITIAL_PORTUGUESE_FAMILY"
          key="INITIAL_PORTUGUESE_FAMILY"
        >
          Plano Origens
        </MenuItem>
      );
    }

    if (filterProcessesNoCourtesy.length >= 5) {
      items.push(
        <MenuItem value="SMALL_PORTUGUESE_FAMILY" key="SMALL_PORTUGUESE_FAMILY">
          Plano Sucessões
        </MenuItem>
      );
    }

    if (filterProcessesNoCourtesy.length >= 8) {
      items.push(
        <MenuItem value="BIG_PORTUGUESE_FAMILY" key="BIG_PORTUGUESE_FAMILY">
          Plano Gerações
        </MenuItem>
      );
    }

  items.push(
    <MenuItem value="ESSENTIAL" key="ESSENTIAL">
      Essencial
    </MenuItem>
  );

  items.push(
    <MenuItem value="PREMIUM" key="PREMIUM">
      Premium
    </MenuItem>
  );

  items.push(
    <MenuItem value="EXCLUSIVE" key="EXCLUSIVE">
      Exclusivo
    </MenuItem>
  );

  return items;
};

export const filterProcessesApensados = processes => {
  if (!Array.isArray(processes) || processes.length === 0) {
    return [];
  }

  return processes.filter(process => Boolean(process.apensado));
};
